<template>
	<div class="device-analysis-page">
		<div class="device-sidebar">
			<div class="device-list-card">
				<div class="card-title">
					<div class="card-title-icon">
						<img src="../../../static/站点列表(1).png"/>
					</div>
					<div class="card-title-text">设备列表</div>
				</div>
				<div class="device-filter">
					<div class="search-row">
						<el-select
						  v-model="query.id"
						  class="station-select"
						  :title="selectedDeviceName"
						  placeholder="请选择设备"
						  clearable
						  filterable
						  :filter-method="deviceFilterMethod"
						  @focus="handleDeviceFocus">
							<el-option v-for="item in filteredDeviceList" :label="item.deviceName" :key="item.id" :value="item.id">
								{{item.deviceName}}
							</el-option>
						</el-select>
						<el-button type="primary" icon="el-icon-search" class="search-btn" @click="refreshDeviceList()">搜索</el-button>
					</div>
					<div class="device-type-tabs">
						<div class="device-type-tab" :class="selectIndex==0?'a-analysis-select':'a-analysis-no'" @click="changType(0);">
							控制器({{controllNum}})
						</div>
						<div class="device-type-tab" :class="selectIndex==1?'a-analysis-select':'a-analysis-no'" @click="changType(1);">
							电表({{dianBiaoNum}})
						</div>
					</div>
				</div>
				<div class="device-list-scroll">
					<div class="device-list-item"
					v-for="(item,index) in tableData" :key="item.id || index" @click="optData(item.id);"
					:class="currentId == item.id ?'selectIt':'selectNo'">
						<div class="device-item-head">
							<div class="device-item-name" :title="item.deviceName">{{item.deviceName}}</div>
							<div class="device-item-type" :title="item.typeNo">{{item.typeNo}}</div>
						</div>
						<div class="device-item-line" :title="item.stationName">
							<span class="device-item-label">电站</span>
							<span class="device-item-value">{{item.stationName}}</span>
						</div>
						<div class="device-item-meta">
							<span v-if="item.deviceStatus == 1" class="status-dot status-offline">离线</span>
							<span v-if="item.deviceStatus == 2" class="status-dot status-online">在线</span>
							<span class="device-item-version">版本：{{item.versionNo}}</span>
						</div>
						<div class="device-item-line" :title="item.serNo">
							<span class="device-item-label">串号</span>
							<span class="device-item-value">{{item.serNo}}</span>
						</div>
					</div>
					<div v-if="tableData.length === 0" class="empty-tip">暂无设备数据</div>
				</div>
			</div>
		</div>
		<div class="device-content">
			<div class="device-summary-card">
				<div class="card-title">
					<div class="card-title-icon">
						<img src="../../../static/设备工况(1).png"/>
					</div>
					<div class="card-title-text">设备信息</div>
					<div class="device-status-tag status-offline-tag" v-if="formObject.deviceStatus == 1">离线</div>
					<div class="device-status-tag status-online-tag" v-if="formObject.deviceStatus == 2">在线</div>
				</div>
				<div class="device-summary-body">
					<div class="device-summary-main">
						<div class="device-summary-name" :title="formObject.deviceName">
							{{formObject.deviceName ? formObject.deviceName : '暂无设备'}}
						</div>
						<div class="device-summary-sub">
							{{formObject.stationName ? formObject.stationName : '暂无所属电站'}}
						</div>
					</div>
					<div class="device-info-grid">
						<div class="device-info-item">
							<div class="device-info-label">串号</div>
							<div class="device-info-value" :title="formObject.serNo">{{formObject.serNo ? formObject.serNo : '暂无'}}</div>
						</div>
						<div class="device-info-item">
							<div class="device-info-label">设备类型</div>
							<div class="device-info-value" v-if="selectIndex == 1">电表</div>
							<div class="device-info-value" v-else-if="formObject.deviceType == 1">控制器</div>
							<div class="device-info-value" v-else-if="formObject.deviceType == 2">电表</div>
							<div class="device-info-value" v-else-if="formObject.deviceType == 3">逆变器</div>
							<div class="device-info-value" v-else>暂无</div>
						</div>
						<div class="device-info-item">
							<div class="device-info-label">型号</div>
							<div class="device-info-value" :title="formObject.typeNo">{{formObject.typeNo ? formObject.typeNo : '暂无'}}</div>
						</div>
						<div class="device-info-item">
							<div class="device-info-label">版本号</div>
							<div class="device-info-value" :title="formObject.versionNo">{{formObject.versionNo ? formObject.versionNo : '暂无'}}</div>
						</div>
						<div class="device-info-item">
							<div class="device-info-label">DTU设备</div>
							<div class="device-info-value" :title="formObject.powerStationDtuText">{{formObject.powerStationDtuText ? formObject.powerStationDtuText : '暂无'}}</div>
						</div>
						<div class="device-info-item">
							<div class="device-info-label">设备地址</div>
							<div class="device-info-value" :title="formObject.address">{{formObject.address ? formObject.address : '暂无'}}</div>
						</div>
						<div class="device-info-item device-info-wide">
							<div class="device-info-label">连接时间</div>
							<div class="device-info-value" :title="formObject.lastConnetTime">{{formObject.lastConnetTime ? formObject.lastConnetTime : '暂无'}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="history-panel">
				<div class="card-title history-title">
					<div class="card-title-icon">
						<img src="../../../static/发电量统计(1).png"/>
					</div>
					<div class="card-title-text">历史数据</div>
					<div class="history-tools">
						<el-date-picker
						  v-model="value1"
						  :type="isMobileViewport ? 'daterange' : 'datetimerange'"
						  :range-separator="isMobileViewport ? '-' : '至'"
						  :start-placeholder="isMobileViewport ? '开始' : '开始日期'"
						  :end-placeholder="isMobileViewport ? '结束' : '结束日期'"
						  :default-time="['00:00:00', '23:59:59']"
						  popper-class="device-analysis-date-popper">
						</el-date-picker>
						<el-button type="primary" icon="el-icon-search" class="query-btn" @click="loadChartData();">查询</el-button>
					</div>
				</div>
				<div class="metric-tabs" v-if="selectIndex==0">
					<div v-for="(item,index) in type1" :key="item" :class="optTypeIndex==index?'optSelect':'optNoSelect'"
					@click="optTypeIndex = index;selectIndex = 0;loadChartData();">
						{{item}}
					</div>
				</div>
				<div class="metric-tabs" v-if="selectIndex==1">
					<div v-for="(item,index) in type2" :key="item" :class="optTypeIndex==index?'optSelect':'optNoSelect'"
					@click="optTypeIndex = index;selectIndex = 1;loadChartData();">
						{{item}}
					</div>
				</div>
				<div ref="allCharts" id="deviceAnalysisChart" class="chartsBox history-chart"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'deviceAnalysis',
	    data() {
		  return {
			  seriesColor: ['#00CCFF', '#0099FF', '#0066CC', '#B0E2FF', '#87CEFA', '#003C66', '#4E4351', '#CE40F6', '#D80510', '#00BBFF'],
			  myChart: null,
			  chartResizeObserver: null,
			  chartMobileLayout: null,
			  isMobileViewport: typeof window !== 'undefined' && window.innerWidth <= 760,
			  chartRequestId: 0,
			  pageRequestId: 0,
			  channelDatay:[],
			  allChartTabTitle:[],
			  channelDatax:[],
			  series:[],
			  optTypeIndex:0,
			  type1:["光伏输入电压","模组输出电流","输出电压","输出总电流","输出总功率"],
			  type2:["第一路电压","总电流","总有功功率","总正向有功电能"],
			  value1:'',
			  clickIndex:-1,
			  formObject:{},
			  currentId:0,
			  dianBiaoNum:0,
			  tableData:[],
			  controllNum:0,
			  selectIndex:0,
			  query:{
				  id:'',
				  deviceType:1,
				  pageNum:1,
				  pageSize:10000,
			  },
			  deviceList:[],
			  filteredDeviceList:[]
		  }
		},
		computed: {
			selectedDeviceName() {
				const device = this.deviceList.find(item => item.id === this.query.id);
				return device && device.deviceName ? device.deviceName : '';
			}
		},
		mounted() {
			this.loadDeviceList();
			this.loadPage();
			this.$nextTick(() => {
				this.observeChartSize();
			})
		},
		beforeDestroy() {
			// 使离开页面后才返回的异步请求失效，避免回调操作下一个路由页面。
			this.chartRequestId++;
			this.pageRequestId++;
			window.removeEventListener('resize', this.resizeChart);
			if (this.chartResizeObserver) {
				this.chartResizeObserver.disconnect();
				this.chartResizeObserver = null;
			}
			if (this.myChart) {
				this.myChart.dispose();
				this.myChart = null;
			}
		},
		methods:{
			getChartDom() {
				const chartRef = this.$refs.allCharts;
				if (chartRef && chartRef.nodeType === 1) return chartRef;
				if (chartRef && chartRef.$el && chartRef.$el.nodeType === 1) return chartRef.$el;
				return null;
			},
			observeChartSize() {
				window.addEventListener('resize', this.resizeChart);
				const chartDom = this.getChartDom();
				if (!chartDom || typeof ResizeObserver === 'undefined') return;

				// 路由进入时 el-collapse-transition 会持续改变页面高度。
				// 监听图表容器的实际尺寸，在动画展开后让 ECharts 重新布局。
				if (this.chartResizeObserver) this.chartResizeObserver.disconnect();
				this.chartResizeObserver = new ResizeObserver(entries => {
					const rect = entries[0] && entries[0].contentRect;
					if (rect && rect.width > 0 && rect.height > 0) {
						this.resizeChart();
					}
				});
				this.chartResizeObserver.observe(chartDom);
			},
			resizeChart() {
				const isMobile = window.innerWidth <= 760;
				if (this.isMobileViewport !== isMobile) this.isMobileViewport = isMobile;
				if (!this.myChart) return;
				if (this.chartMobileLayout !== isMobile) {
					this.myChart.setOption(this.getChartLayout(isMobile));
					this.chartMobileLayout = isMobile;
				}
				this.myChart.resize();
			},
			getChartLayout(isMobile) {
				return {
					tooltip: {
						triggerOn: isMobile ? 'click' : 'mousemove'
					},
					legend: isMobile ? {
						type: 'scroll',
						orient: 'horizontal',
						left: 12,
						right: 12,
						top: 12,
						padding: 0
					} : {
						type: 'plain',
						orient: 'vertical',
						left: 'auto',
						right: 0,
						top: 'middle',
						padding: [0, 50, 0, 0]
					},
					grid: isMobile ? {
						left: 10,
						right: 12,
						top: 58,
						bottom: 22,
						containLabel: true
					} : {
						left: '3%',
						right: '15%',
						top: '8%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						axisLabel: {
							rotate: isMobile ? 35 : 0,
							fontSize: isMobile ? 10 : 12
						}
					}
				};
			},
			/**
			 * 初始化折线图
			 * @param {Object} id
			 * @param {Object} series
			 * @param {Object} datax
			 * @param {Object} showed
			 */
			initCharts(id, series, datax,showed) {
			  const chartDom = this.getChartDom(id);
			  if (!chartDom) return;
			  const isMobile = window.innerWidth <= 760;
			  const chartLayout = this.getChartLayout(isMobile);
			  this.myChart = this.$echarts.getInstanceByDom(chartDom) || this.$echarts.init(chartDom)
			  this.myChart.setOption({
			    title: {
			      show: showed,
			      text: '暂无数据',
			      left: 'center',
			      top: 'center',
			      textStyle: {
			        fontWeight: 'normal',
			        color: '#87CEFA'
			      }
			    },
			    tooltip: {
			      trigger: 'axis',
			      triggerOn: chartLayout.tooltip.triggerOn,
			      className: 'custom-tooltip-box2',
			      textStyle: {
			        color: "white"
			      },
			      backgroundColor: 'rgba(0, 43, 77, 0.9)'
			    },
			    legend: {
			      type: chartLayout.legend.type,
			      itemHeight: 4,
			      itemWidth: 12,
			      textStyle: {
			        color: "#87CEFA",
			      },
			      icon: 'rect',
			      orient: chartLayout.legend.orient,
			      left: chartLayout.legend.left,
			      right: chartLayout.legend.right,
			      top: chartLayout.legend.top,
			      padding: chartLayout.legend.padding
			    },
			    grid: chartLayout.grid,
			    xAxis: {
			      boundaryGap: false,
			      scale: false,
			      type: 'category',
			      data: datax,
			      axisLabel: {
			        inside: false,
			        color: '#87CEFA',
			        show: true,
			        showMaxLabel: true,
			        rotate: chartLayout.xAxis.axisLabel.rotate,
			        fontSize: chartLayout.xAxis.axisLabel.fontSize
			      },
			      axisTick: {
			        show: true,
			        lineStyle: {
			          color: '#003567'
		        }
			      },
			      axisLine: {
			        show: true,
			        lineStyle: {
			          color: '#003567'
		        }
			      },
			      z: 10
			    },
			    yAxis: {
			      type: 'value',
			      scale: true,
			      axisTick: {
			        show: true,
			        lineStyle: {
			          color: '#003567'
		        }
			      },
			      axisLine: {
			        show: true,
			        lineStyle: {
			          color: '#003567'
		        }
			      },
			      axisLabel: {
			        color: '#87CEFA'
			      },
			      splitLine: {
			        lineStyle: {
			          color: "rgba(0, 153, 255, 0.2)"
			       },
			      }
			    },
			    dataZoom: isMobile && datax.length > 24 ? [{
			      type: 'inside',
			      startValue: Math.max(datax.length - 24, 0),
			      endValue: datax.length - 1
			    }] : [],
			    series: series
			  },true)
			  this.chartMobileLayout = isMobile;
			  this.$nextTick(this.resizeChart);
			},
			//加载折线图
			loadChartData(){
				if (!this.currentId) return;
				const requestId = ++this.chartRequestId;
				const chartSelectIndex = this.selectIndex === 1 ? 1 : 0;
				let request;
				if(Array.isArray(this.value1) && this.value1.length === 2){
				    request = {id:this.currentId,type:this.optTypeIndex,startTime:this.value1[0],endTime:this.value1[1],selectIndex:chartSelectIndex};
				}else{
					request = {id:this.currentId,type:this.optTypeIndex,selectIndex:chartSelectIndex};
				}
				this.$request.post('/api/device/chart/data',request).then(response => {
					if (requestId !== this.chartRequestId) return;
					if(response.data.result){
						const chartRows = Array.isArray(response.data.data)
							? response.data.data.filter(item => item && Array.isArray(item.datas))
							: [];
						if (chartRows.length === 0) {
							this.initCharts('allCharts', [], [], true);
							return;
						}
						const titles = [];
						chartRows.forEach(row => {
							row.datas.forEach(item => {
								if (item && item.title && !titles.includes(item.title)) titles.push(item.title);
							});
						});
						this.channelDatax = chartRows.map(item => item.dateTime);
						this.series = titles.map((title, index) => {
						  const color = this.seriesColor[index % this.seriesColor.length];
						  return {
						    name: title,
						    type: 'line',
						    data: chartRows.map(row => {
								const point = row.datas.find(item => item && item.title === title);
								if (!point || point.value === null || point.value === undefined || point.value === '') return null;
								const value = Number(point.value);
								return Number.isNaN(value) ? null : value;
						    }),
						    smooth: true,
						    symbol: 'none',
						    itemStyle: {
						      normal: {
						        color: color,
						        lineStyle: {
						          color: color
						        }
						      }
						    }
						  };
						});
						this.initCharts('allCharts', this.series, this.channelDatax,false);
					}else{
						this.$Message.error("获取数据失败,请联系管理员!");
					}
				}).catch(() => {
					if (requestId !== this.chartRequestId) return;
					this.initCharts('allCharts', [], [], true);
					this.$Message.error("网络异常，获取历史数据失败！");
				})
			},
			//加载设备详情数据
			infoView(id){
				this.$request.get('/api/device/info/'+id).then(response => {
					if(response.data.result){
						this.formObject = response.data.data;
					}else{
						this.$Message.error("获取数据失败,请联系管理员!");
					}
				})
			},
			//取数
			optData(id){
				this.currentId = id;
				this.infoView(id);
				this.loadChartData();
			},
			refreshDeviceList(){
				this.loadPage();
			},
			/**
			 * 加载分页
			 */
			loadPage(){
				// 电表数据来自控制器，两个标签共用同一份控制器设备列表。
				this.query.deviceType = 1;
				const requestId = ++this.pageRequestId;
				const query = Object.assign({}, this.query);
				this.$request.post("/api/device/page",query).then(response =>{
					if (requestId !== this.pageRequestId) return;
					if(response.data.result){
						const data = response.data.data || {};
						this.tableData = Array.isArray(data.list) ? data.list : [];
						const totalCount = Number(data.totalCount) || 0;
						this.controllNum = totalCount;
						this.dianBiaoNum = totalCount;
						if(this.tableData.length > 0){
							this.optData(this.tableData[0].id);
						}else{
							this.currentId = 0;
							this.formObject = {};
							this.initCharts('allCharts', [], [], true);
						}
					}else{
						this.$Message.error("获取数据失败,请联系管理员!");
					}
				}).catch(() => {
					if (requestId !== this.pageRequestId) return;
					this.tableData = [];
					this.currentId = 0;
					this.formObject = {};
					this.initCharts('allCharts', [], [], true);
					this.$Message.error("网络异常，获取设备列表失败！");
				})
			},
			changType(i){
				this.selectIndex = i;
				this.optTypeIndex = 0;
				if (this.currentId) {
					this.loadChartData();
				} else {
					this.loadPage();
				}
			},
			// 分析页设备下拉列表；电表数据同样归属于控制器设备
			loadDeviceList(){
				const query = {pageNum: 1, pageSize: 10000, deviceType: 1};
				this.$request.post("/api/device/page", query).then(response =>{
					if(response.data.result){
						const data = response.data.data || {};
						this.deviceList = Array.isArray(data.list) ? data.list : [];
						this.filteredDeviceList = this.deviceList.slice();
					}else{
						this.$Message.error("获取数据失败,请联系管理员!");
					}
				}).catch(() => {
					this.$Message.error("网络异常，获取设备列表失败！");
				})
			},
			deviceFilterMethod(val) {
				const keyword = String(val || '').trim().toLocaleLowerCase();
				if (!keyword) {
					this.filteredDeviceList = this.deviceList.slice();
					return;
				}
				this.filteredDeviceList = this.deviceList.filter(item =>
					String(item.deviceName || '').toLocaleLowerCase().includes(keyword)
				);
			},
			handleDeviceFocus() {
				this.filteredDeviceList = this.deviceList.slice();
			}
		}
	}
</script>

<style>
	.device-analysis-date-popper.el-picker-panel,
	.device-analysis-date-popper .el-picker-panel,
	.device-analysis-date-popper .el-date-range-picker,
	.device-analysis-date-popper .el-time-panel{
		border-color: #003567 !important;
		background-color: #002B4D !important;
		color: #87CEFA !important;
		box-shadow: 0 12px 32px rgba(0, 10, 24, 0.45) !important;
	}
	.device-analysis-date-popper .el-picker-panel__body,
	.device-analysis-date-popper .el-date-range-picker__content,
	.device-analysis-date-popper .el-time-panel__content{
		background-color: #002B4D !important;
	}
	.device-analysis-date-popper .el-date-range-picker__content.is-left{
		border-right-color: #003567 !important;
	}
	.device-analysis-date-popper .el-date-table th,
	.device-analysis-date-popper .el-picker-panel__icon-btn,
	.device-analysis-date-popper .el-date-range-picker__header,
	.device-analysis-date-popper .el-date-range-picker__content .el-date-range-picker__header div,
	.device-analysis-date-popper .el-time-panel__btn,
	.device-analysis-date-popper .el-time-spinner__item{
		color: #B0E2FF !important;
	}
	.device-analysis-date-popper .el-date-table th{
		border-bottom-color: #003567 !important;
	}
	.device-analysis-date-popper .el-date-table td.next-month,
	.device-analysis-date-popper .el-date-table td.prev-month{
		color: #3D6585 !important;
	}
	.device-analysis-date-popper .el-date-table td.available:hover,
	.device-analysis-date-popper .el-time-spinner__item:hover:not(.disabled):not(.active){
		color: #00CCFF !important;
	}
	.device-analysis-date-popper .el-date-table td.in-range div,
	.device-analysis-date-popper .el-date-table td.in-range div:hover{
		background-color: rgba(0, 153, 255, 0.18) !important;
	}
	.device-analysis-date-popper .el-date-table td.today span,
	.device-analysis-date-popper .el-time-spinner__item.active:not(.disabled){
		color: #00CCFF !important;
		font-weight: 600;
	}
	.device-analysis-date-popper .el-date-table td.current:not(.disabled) span,
	.device-analysis-date-popper .el-date-table td.start-date span,
	.device-analysis-date-popper .el-date-table td.end-date span{
		background-color: #0099FF !important;
		color: #002B4D !important;
	}
	.device-analysis-date-popper .el-date-table td.disabled div{
		background-color: #001A33 !important;
		color: #3D6585 !important;
	}
	.device-analysis-date-popper .el-picker-panel__footer,
	.device-analysis-date-popper .el-time-panel__footer{
		border-top-color: #003567 !important;
		background-color: #002B4D !important;
	}
	.device-analysis-date-popper .el-picker-panel__footer .el-button{
		min-width: 54px;
		padding-left: 12px;
		padding-right: 12px;
	}
	.device-analysis-date-popper .el-button--text,
	.device-analysis-date-popper .el-time-panel__btn.confirm{
		color: #00CCFF !important;
	}
	.device-analysis-date-popper .el-button--default{
		border-color: #0076B8 !important;
		background-color: #001A33 !important;
		color: #87CEFA !important;
	}
	.device-analysis-date-popper .el-button--primary{
		border-color: #0099FF !important;
		background-color: #0099FF !important;
		color: #002B4D !important;
	}
	.device-analysis-date-popper[x-placement^="bottom"] .popper__arrow,
	.device-analysis-date-popper[x-placement^="bottom"] .popper__arrow::after{
		border-bottom-color: #002B4D !important;
	}
	.device-analysis-date-popper[x-placement^="top"] .popper__arrow,
	.device-analysis-date-popper[x-placement^="top"] .popper__arrow::after{
		border-top-color: #002B4D !important;
	}
	@media (max-width: 760px) {
		.device-analysis-date-popper.el-picker-panel{
			box-sizing: border-box;
			width: calc(100vw - 16px) !important;
			max-width: calc(100vw - 16px) !important;
			max-height: calc(100vh - 16px);
			overflow-x: hidden;
			overflow-y: auto;
		}
		.device-analysis-date-popper .el-picker-panel__body{
			min-width: 0 !important;
		}
		.device-analysis-date-popper .el-date-range-picker__content{
			box-sizing: border-box;
			width: 100% !important;
			padding: 10px 12px;
		}
		.device-analysis-date-popper .el-date-range-picker__content.is-left{
			border-right: 0 !important;
		}
		.device-analysis-date-popper .el-date-range-picker__content.is-right{
			border-top: 1px solid #003567;
		}
		.device-analysis-date-popper .el-date-table td{
			padding: 2px 0;
		}
	}
</style>

<style scoped>
	.device-analysis-page{
		display: flex;
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		overflow: hidden;
		background-color: #001A33;
	}
	.device-sidebar{
		flex: 0 0 300px;
		width: 300px;
		height: 100%;
		box-sizing: border-box;
		padding: 4px 0 8px 4px;
	}
	.device-list-card,
	.device-summary-card,
	.history-panel{
		box-sizing: border-box;
		border: 1px solid #003567;
		border-radius: 12px;
		background-color: #002B4D;
		overflow: hidden;
	}
	.device-list-card{
		display: flex;
		flex-direction: column;
		width: 292px;
		height: 100%;
	}
	.card-title{
		display: flex;
		align-items: center;
		box-sizing: border-box;
		width: 100%;
		height: 48px;
		border-bottom: 2px solid #003567;
		overflow: hidden;
	}
	.card-title-icon{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 20px;
	}
	.card-title-icon img{
		display: block;
	}
	.card-title-text{
		margin-left: 10px;
		color: #87CEFA;
		font-size: 14px;
		line-height: 1;
		white-space: nowrap;
	}
	.device-filter{
		box-sizing: border-box;
		padding: 12px 10px 0;
	}
	.station-select{
		flex: 1;
		min-width: 0;
	}
	.search-row{
		display: flex;
		align-items: center;
	}
	.search-row .el-input{
		flex: 1;
		min-width: 0;
	}
	.search-btn,
	.query-btn{
		height: 36px;
		border-radius: 4px;
		background-color: #0099FF !important;
		border-color: #0099FF !important;
		color: #002B4D !important;
		font-size: 14px;
		font-weight: 600;
		line-height: 1;
	}
	.search-btn{
		width: 82px;
		margin-left: 4px;
	}
	.query-btn{
		width: 88px;
		margin-left: 12px;
	}
	/deep/ .search-btn.el-button span,
	/deep/ .search-btn.el-button i,
	/deep/ .query-btn.el-button span,
	/deep/ .query-btn.el-button i{
		color: #002B4D !important;
	}
	.device-type-tabs{
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 10px;
		margin-top: 12px;
	}
	.device-type-tab{
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		height: 34px;
		border-radius: 6px;
		font-size: 12px;
		cursor: pointer;
		white-space: nowrap;
	}
	.a-analysis-no{
		color: #87CEFA;
		background-color: #002B4D;
		border: 1px solid #0076B8;
		box-shadow: inset 0 0 0 1px rgba(0, 153, 255, 0.18);
	}
	.a-analysis-select{
		color: #002B4D;
		background-color: #0099FF;
		border: 1px solid #66C7FF;
		font-weight: 600;
	}
	.device-list-scroll{
		flex: 1;
		min-height: 0;
		margin-top: 12px;
		padding: 0 10px 12px;
		overflow-y: auto;
	}
	.device-list-item{
		box-sizing: border-box;
		width: 100%;
		min-height: 108px;
		margin-top: 10px;
		padding: 10px 12px;
		border-radius: 10px;
		cursor: pointer;
	}
	.selectNo{
		border: 1px solid #0076B8;
		background-color: #001A33;
		color: #87CEFA;
		box-shadow: inset 0 0 0 1px rgba(0, 153, 255, 0.16);
	}
	.selectIt{
		border: 1px solid #0099FF;
		background: rgba(0, 153, 255, 0.16);
		color: #B0E2FF;
		box-shadow: inset 3px 0 0 #0099FF;
	}
	.selectIt .device-item-name,
	.selectIt .device-item-value{
		color: #FFFFFF;
	}
	.selectIt .device-item-type,
	.selectIt .device-item-version{
		color: #B0E2FF;
	}
	.selectIt .device-item-label{
		color: #87CEFA;
	}
	.device-item-head,
	.device-item-meta,
	.device-item-line{
		display: flex;
		align-items: center;
		min-width: 0;
	}
	.device-item-head{
		margin-bottom: 8px;
	}
	.device-item-name{
		flex: 1;
		min-width: 0;
		color: #B0E2FF;
		font-size: 14px;
		font-weight: 600;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.device-item-type{
		max-width: 66px;
		margin-left: 8px;
		color: #6699CC;
		font-size: 12px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.device-item-line{
		margin-top: 6px;
		font-size: 12px;
		line-height: 18px;
	}
	.device-item-label{
		flex: 0 0 32px;
		color: #6699CC;
	}
	.device-item-value{
		flex: 1;
		min-width: 0;
		color: #87CEFA;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.device-item-meta{
		margin-top: 6px;
		font-size: 12px;
	}
	.status-dot{
		display: inline-flex;
		align-items: center;
		min-width: 34px;
	}
	.status-online{
		color: #00CCFF;
	}
	.status-offline{
		color: #FF6B6B;
	}
	.device-item-version{
		margin-left: 14px;
		color: #87CEFA;
	}
	.empty-tip{
		padding-top: 40px;
		color: #6699CC;
		font-size: 14px;
		text-align: center;
	}
	.device-content{
		flex: 1;
		min-width: 0;
		box-sizing: border-box;
		padding: 4px 8px;
		overflow: hidden;
	}
	.device-summary-card{
		height: 196px;
	}
	.device-status-tag{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 76px;
		height: 26px;
		margin-left: auto;
		margin-right: 16px;
		border-radius: 4px;
		font-size: 13px;
		font-weight: 600;
	}
	.status-offline-tag{
		border: 1px solid #FF6B6B;
		background-color: #001A33;
		color: #FF6B6B;
	}
	.status-online-tag{
		border: 1px solid #00CCFF;
		background-color: #001A33;
		color: #00CCFF;
	}
	.device-summary-body{
		display: flex;
		align-items: center;
		box-sizing: border-box;
		height: 146px;
		padding: 14px 18px;
	}
	.device-summary-main{
		display: flex;
		flex: 0 0 250px;
		flex-direction: column;
		align-self: stretch;
		justify-content: center;
		box-sizing: border-box;
		min-width: 0;
		padding: 0 18px;
		border: 1px solid #003567;
		border-radius: 6px;
		background-color: #001A33;
	}
	.device-summary-name{
		color: #FFFFFF;
		font-size: 24px;
		font-weight: 700;
		line-height: 32px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.device-summary-sub{
		margin-top: 8px;
		color: #6699CC;
		font-size: 14px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.device-info-grid{
		display: grid;
		flex: 1;
		align-self: stretch;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		grid-template-rows: repeat(2, minmax(0, 1fr));
		align-content: stretch;
		gap: 10px;
		min-width: 0;
		margin-left: 14px;
	}
	.device-info-item{
		display: flex;
		flex-direction: column;
		justify-content: center;
		box-sizing: border-box;
		min-width: 0;
		padding: 6px 12px;
		border: 1px solid #003567;
		border-radius: 6px;
		background-color: #001A33;
	}
	.device-info-wide{
		grid-column: span 2;
	}
	.device-info-label{
		color: #6699CC;
		font-size: 12px;
		line-height: 16px;
	}
	.device-info-value{
		margin-top: 2px;
		color: #87CEFA;
		font-size: 14px;
		line-height: 18px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.history-panel{
		height: calc(100% - 212px);
		margin-top: 12px;
		border-color: #0076B8;
		box-shadow: inset 0 0 0 1px rgba(0, 153, 255, 0.16);
	}
	.history-tools{
		display: flex;
		align-items: center;
		margin-left: auto;
		margin-right: 14px;
	}
	.metric-tabs{
		display: flex;
		align-items: center;
		box-sizing: border-box;
		width: calc(100% - 28px);
		height: 48px;
		margin-left: 14px;
		border-bottom: 1px solid #003567;
		overflow-x: auto;
		overflow-y: hidden;
	}
	.optNoSelect,
	.optSelect{
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		height: 32px;
		padding: 0 14px;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
		font-weight: 500;
		white-space: nowrap;
	}
	.optNoSelect + .optNoSelect,
	.optNoSelect + .optSelect,
	.optSelect + .optNoSelect,
	.optSelect + .optSelect{
		margin-left: 8px;
	}
	.optNoSelect{
		border: 1px solid #003567;
		background-color: #002B4D;
		color: #87CEFA;
	}
	.optSelect{
		border: 1px solid #0099FF;
		background-color: #0099FF;
		color: #002B4D;
		font-weight: 600;
	}
	.history-chart{
		width: 100%;
		height: calc(100% - 96px);
		background-color: #001A33;
	}
	/deep/ .el-input__inner,
	/deep/ .el-range-editor.el-input__inner{
		border-color: #003567 !important;
		background-color: #001A33 !important;
		color: #87CEFA !important;
	}
	/deep/ .el-input__inner::placeholder{
		color: #6699CC;
	}
	/deep/ .el-date-editor .el-range-input{
		background-color: transparent;
		color: #87CEFA;
	}
	/deep/ .el-date-editor .el-range-separator{
		color: #87CEFA;
		visibility: visible;
	}
	/deep/ .el-date-editor .el-range__icon,
	/deep/ .el-date-editor .el-range__close-icon,
	/deep/ .el-select .el-input .el-select__caret{
		color: #6699CC;
	}
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background-color: #001A33;
	}
	::-webkit-scrollbar-thumb {
		background-color: #0099FF;
		border-radius: 3px;
	}
	::-webkit-scrollbar-track {
		background-color: #002B4D;
		border-radius: 3px;
	}
	@media (max-width: 980px) {
		.device-analysis-page{
			overflow-x: hidden;
			overflow-y: auto;
			-webkit-overflow-scrolling: touch;
		}
		.device-content{
			overflow: visible;
		}
		.device-summary-body{
			height: auto;
			flex-direction: column;
		}
		.device-summary-card{
			height: auto;
		}
		.device-summary-main{
			flex: none;
			width: 100%;
			min-height: 92px;
		}
		.device-info-grid{
			width: 100%;
			grid-template-columns: repeat(2, minmax(0, 1fr));
			margin-top: 12px;
			margin-left: 0;
		}
		.history-panel{
			height: 520px;
		}
		.history-title{
			flex-wrap: wrap;
			height: auto;
			padding: 8px 12px;
		}
		.history-title .card-title-icon{
			margin-left: 0;
		}
		.history-tools{
			order: 2;
			flex: 1 0 100%;
			gap: 8px;
			min-width: 0;
			margin: 8px 0 0;
		}
		/deep/ .history-tools .el-date-editor{
			flex: 1 1 auto;
			width: auto !important;
			min-width: 0;
		}
		.query-btn{
			flex: 0 0 88px;
			margin-left: 0;
		}
		.history-chart{
			height: calc(100% - 150px);
		}
	}

	@media (max-width: 760px) {
		.device-analysis-page{
			display: block;
			height: 100%;
			padding: 8px;
		}
		.device-sidebar{
			width: 100%;
			height: auto;
			padding: 0;
		}
		.device-list-card{
			width: 100%;
			height: auto;
		}
		.device-list-card,
		.device-summary-card,
		.history-panel{
			border-radius: 10px;
		}
		.card-title{
			height: 46px;
		}
		.card-title-icon{
			margin-left: 14px;
		}
		.card-title-text{
			margin-left: 8px;
		}
		.device-filter{
			padding: 10px 10px 0;
		}
		.search-row{
			gap: 8px;
		}
		.search-btn,
		.query-btn{
			min-height: 44px;
		}
		.search-btn{
			width: 76px;
			margin-left: 0;
		}
		.device-type-tabs{
			gap: 8px;
			margin-top: 10px;
		}
		.device-type-tab{
			height: 44px;
			font-size: 13px;
			touch-action: manipulation;
		}
		.device-list-scroll{
			display: flex;
			flex: none;
			gap: 10px;
			margin-top: 10px;
			padding: 0 10px 12px;
			overflow-x: auto;
			overflow-y: hidden;
			overscroll-behavior-x: contain;
			scroll-padding-left: 10px;
			scroll-snap-type: x proximity;
		}
		.device-list-item{
			flex: 0 0 min(78vw, 280px);
			min-height: 116px;
			margin-top: 0;
			scroll-snap-align: start;
			touch-action: manipulation;
		}
		.empty-tip{
			width: 100%;
			padding: 26px 0;
		}
		.device-content{
			width: 100%;
			padding: 0;
		}
		.device-summary-card{
			margin-top: 10px;
		}
		.device-status-tag{
			width: auto;
			min-width: 56px;
			height: 28px;
			margin-right: 12px;
			padding: 0 8px;
		}
		.device-summary-body{
			padding: 12px;
		}
		.device-summary-main{
			min-height: 88px;
			padding: 14px;
		}
		.device-summary-name{
			font-size: 20px;
			line-height: 28px;
		}
		.device-summary-sub{
			margin-top: 4px;
		}
		.device-info-grid{
			gap: 8px;
		}
		.device-info-item{
			min-height: 64px;
			padding: 8px 10px;
		}
		.history-panel{
			height: auto;
			margin-top: 10px;
			margin-bottom: 8px;
		}
		.history-title{
			flex-wrap: wrap;
			height: auto;
			padding: 10px 12px;
		}
		.history-title .card-title-icon{
			margin-left: 0;
		}
		.history-tools{
			order: 2;
			flex: 1 0 100%;
			gap: 8px;
			min-width: 0;
			margin: 10px 0 0;
		}
		/deep/ .history-tools .el-date-editor{
			flex: 1 1 auto;
			width: auto !important;
			min-width: 0;
		}
		/deep/ .history-tools .el-range-editor.el-input__inner{
			height: 44px;
			padding: 3px 8px;
		}
		/deep/ .history-tools .el-range-input{
			min-width: 0;
			font-size: 12px;
		}
		/deep/ .history-tools .el-range-separator{
			width: 16px;
			font-size: 12px;
		}
		.query-btn{
			flex: 0 0 76px;
			width: 76px;
			margin-left: 0;
		}
		.metric-tabs{
			width: calc(100% - 20px);
			height: 52px;
			margin-left: 10px;
			scroll-padding-left: 2px;
			scroll-snap-type: x proximity;
		}
		.optNoSelect,
		.optSelect{
			min-height: 40px;
			padding: 0 12px;
			font-size: 13px;
			scroll-snap-align: start;
			touch-action: manipulation;
		}
		.history-chart{
			height: 360px;
		}
	}

	@media (max-width: 400px) {
		.history-tools{
			flex-wrap: wrap;
		}
		/deep/ .history-tools .el-date-editor{
			flex-basis: 100%;
		}
		.query-btn{
			flex-basis: 100%;
			width: 100%;
		}
		.device-info-value{
			font-size: 13px;
		}
	}
</style>
